import React from "react";
import { formatDistanceToNow } from "date-fns";
import { parseDate } from "../../../utils/date";

const TimeAgo = ({ timestamp }) => {
  const parsedDate = parseDate(timestamp);
  if (!parsedDate) {
    return <span></span>;
  }

  // Calculate the time difference and format it
  const timeAgoString = formatDistanceToNow(parsedDate, { addSuffix: true });

  return <span>{timeAgoString}</span>;
};

export default TimeAgo;
